import BaseFile from '@/modules/common/models/file/base-file.ts';
import { uniqueId } from 'lodash-es';
import { IdPrefix } from '@/modules/common/enums/id-prefix.ts';
import { useSyncSystemStore } from '@/modules/core/stores/sync-system.store.ts';
import type DocumentFile from '@/modules/document/models/file/document-file.ts';
import type { FileTemplateResponse } from '@/modules/core/api/route-api.type.ts';

export default class TemplateFile extends BaseFile {
  fileId: number;
  documentId: number;
  hash: string;
  url: string;
  previewUrl: string;

  constructor(response: FileTemplateResponse, file: DocumentFile) {
    super(uniqueId(IdPrefix.TemplateFile), response['Название шаблона'], response['Размер']);

    const syncSystemStore = useSyncSystemStore();

    this.fileId = response['F_ID'];
    this.documentId = response['DOC_ID'];
    this.hash = file.hash;
    this.url = `${syncSystemStore.storageUrl}${this.hash}.${this.extension}`;
    this.previewUrl = `${syncSystemStore.storageUrl}${this.hash}_page0001.jpg`;
  }
}
